import Vue from "vue";
import { simpleFormat } from "@helpers";

function debounce (fn, delay) {
  var timeoutID = null;

  return function () {
    clearTimeout(timeoutID);

    var args = arguments;
    var that = this;

    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

Vue.directive("debounce", {
  bind: function (el, binding, vnode) {
    if (binding.value !== binding.oldValue) { // change debounce only if interval has changed
      el.oninput = debounce(function (evt) {
        el.dispatchEvent(new Event("change"));
      }, parseInt(binding.value) || 500);
    }
  }
});

Vue.directive("raw", {
  bind: function (el, binding, vnode) {
    el.innerHTML = simpleFormat(binding.value);
  },
  update: function (el, binding, vnode) {
    el.innerHTML = simpleFormat(binding.value);
  }
});
